import { Phone } from 'lucide-react';
import { ContactsGrid } from '@/components/forms/ContactsGrid';
import type { EstablishmentContact, EstablishmentFormState } from '@/types/establishment.types';

/** Props for {@link EstablishmentContactsSection}. */
interface Props {
  form: EstablishmentFormState;
  onFieldChange: (field: string, value: unknown) => void;
}

/** Contact people on the establishment form. */
export function EstablishmentContactsSection({ form, onFieldChange }: Readonly<Props>) {
  function handleContactsChange(contacts: EstablishmentContact[]): void {
    onFieldChange('contacts', contacts);
  }

  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <Phone className="w-4 h-4" />
        Fonctions
      </h4>
      <ContactsGrid value={form.contacts} onChange={handleContactsChange} disabled={false} />
      <p className="text-xs text-muted-foreground mt-2">
        Définissez les contacts disponibles dans cet établissement
      </p>
    </div>
  );
}
